// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  cursor: pointer;
}
ion-card ion-card-header {
  display: flex;
  align-items: center;
}
ion-card ion-card-header ion-card-title {
  flex: auto;
  margin-top: 0;
  font-size: 16px;
  font-weight: bold;
}
ion-card ion-card-content {
  padding: 10px;
  border-left: solid 12px var(--ion-color-primary);
}

ion-icon {
  color: var(--ion-color-primary);
  font-size: 20px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/return-search-result/return-search-result.component.scss"],"names":[],"mappings":"AACA;EACI,eAAA;AAAJ;AAEI;EACI,aAAA;EACA,mBAAA;AAAR;AAEQ;EACI,UAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AAAZ;AAII;EACI,aAAA;EACA,gDAAA;AAFR;;AAMA;EACI,+BAAA;EACA,eAAA;EACA,iBAAA;AAHJ","sourcesContent":["\nion-card {\n    cursor: pointer;\n\n    ion-card-header {\n        display: flex;\n        align-items: center;\n\n        ion-card-title {\n            flex: auto;\n            margin-top: 0;\n            font-size: 16px;\n            font-weight: bold;\n        }\n    }\n\n    ion-card-content {\n        padding: 10px;\n        border-left: solid 12px var(--ion-color-primary);\n    }\n}\n\nion-icon {\n    color: var(--ion-color-primary);\n    font-size: 20px;\n    margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
